import { Injectable } from '@angular/core';

import {
  BarcodeScanner,
  BarcodeFormat,
  LensFacing,
} from '@capacitor-mlkit/barcode-scanning';
import { ErrorService } from './error.service';

@Injectable({
  providedIn: 'root'
})
export class BarcodeScannerService {

  constructor(
    private errorService: ErrorService,
  ) { }

  async stopScan() {
    if (BarcodeScanner) {
      try {

        // Make all elements in the WebView visible again
        document.querySelector('body')?.classList.remove('barcode-scanner-active');
        
        // Remove all listeners
        await BarcodeScanner.removeAllListeners();

        // Stop the barcode scanner
        await BarcodeScanner.stopScan();

        await BarcodeScanner.disableTorch();
      } catch (err) {
        this.errorService.logError(err);
      }
    }
  }

}
